import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["video"];

  connect() {
    this.element.addEventListener("hidden.bs.modal", this.pause);
  }

  disconnect() {
    this.element.removeEventListener("hidden.bs.modal", this.pause);
  }

  pause = () => {
    this.videoTarget.pause();
  };
}
